const Cosmetics = [6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,23,24,25,30,31,32,34,55,56,57,58]

export {Cosmetics}